import logoNegro from '../../img/logo.png';
import logoVbrass from '../../img/vbrassLogo.png';
import logoMoradoDegradado from '../../img/logoDegradadoMorado.png';
import './style.css';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';

function Nosotros() {
    const history = useHistory();

    const handleClick = () => {
        history.push('/'); // cambia a la ruta deseada
    };

    return (  
        <div className="nosotros">
            <img src={logoMoradoDegradado} alt="" className='imgFondo'/>
            <div className="row rowLogo">
                <div className="col-4 col-sm-3 col-md-2 col-lg-1 m-0 p-0 d-flex">
                    <img src={logoNegro} alt="" width={'70%'} className='mb-0 mt-auto' onClick={handleClick} style={{ cursor: 'pointer' }}/>
                </div>
            </div>
            <div className="row rowLogoVbrass">
                <div className="col-12">
                    <img src={logoVbrass} alt="" width={'100%'}/>
                </div>
            </div>
            <div className="row rowText mt-4">
                <div className="col-12">
                    <p>
                        Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
                    </p>
                </div>
            </div>
            <div className="row rowBtn mt-4">
                <div className="col-12">
                    <Link to={'/contacto'} className="btn">Contáctanos</Link>
                </div>
            </div>
        </div>
    );
}

export default Nosotros;